import React from "react";
import { Redirect } from "react-router-dom";
import { Mutation } from "react-apollo";
import { CREATE_REGION } from "../../../graphql";
import InputText from "../../UI/Input/Text";
import Text from "../../Type/Text";
import Button from "../../UI/Button";
import OrganizationSelect from "../../Organization/Select/Container"

import {
  Rowz,
  Spacer
} from "../../../components/Layout/Layout";

class RegionRegistrationForm extends React.Component {
  state = {
    name: "",
    place: "",
    refNumber: "",
    organizationID: ""
  };

  handleInputChange = (name, value) => {
    this.setState({
      [name]: value
    });
  };

  
  render() {
    return (
      <Mutation mutation={CREATE_REGION}>
        {(createRegion, { data, loading, called, error }) => {
          if (called && !error && !loading) {
            if (data.createRegion) {
              return (
                <Redirect
                  to={{
                    pathname: "/",
                    state: {
                      message: `Region ${
                        data.createRegion.name
                      } successfully created`
                    }
                  }}
                />
              );
            }
          }

          return (
            <React.Fragment>
              <form
                onSubmit={e => {
                  e.preventDefault();
                  createRegion({ variables: { input: this.state } });
                }}
              >
                <Spacer>
                  <Spacer>
                    <Rowz>
                      <Text>Name:</Text>
                      <InputText
                        name="name"
                        placeholder="Spaarne Ziekenhuis"
                        required
                        onChange={value =>
                          this.handleInputChange("name", value)
                        }
                      />
                    </Rowz>
                  </Spacer>
                  <Spacer>
                    <Rowz>
                      <Text>Place:</Text>
                      <InputText
                        name="place"
                        placeholder="Bijlmer"
                        required
                        onChange={value =>
                          this.handleInputChange("place", value)
                        }
                      />
                    </Rowz>
                  </Spacer>
                  <Spacer>
                    <Rowz>
                      <Text>Reference number:</Text>
                      <InputText
                        name="refNumber"
                        placeholder="12345"
                        required
                        onChange={value =>
                          this.handleInputChange("refNumber", value)
                        }
                      />
                    </Rowz>
                  </Spacer>               
                  <Spacer>
                    <Rowz>
                      <OrganizationSelect required onChange={value=>this.handleInputChange("organizationID",value)}/>
                    </Rowz>
                  </Spacer>

                  <Spacer>
                    <Button type="submit" disabled={loading}>
                      Submit
                    </Button>
                  </Spacer>
                </Spacer>
              </form>
            </React.Fragment>
          );
        }}
      </Mutation>
    );
  }
}

export default RegionRegistrationForm;
